export default {
    userInfo:{},
    isLogin: false,
    indexSearchInfo:{},         //首页展示的信息
    proPageSearchParams:{},     //产品详情页面搜索相关数据
    Authorization:null,
    productShowInfo:{},         //产品详情页头部展示信息
    productRouterInfo:{},       //产品详情页路由传递过来的信息
    conceptList: {},
    colorArr: ['#b44c53', '#925559', '#d16c5d', '#ba774a', '#586d82', '#787d60', '#ca9f51', '#6f8765', '#4d8d7a', '#667c92', '#996b6b', '#a08db4', '#bcbcbb', '#b1b594', '#a49f95', '#ac7a79', '#bebeab', '#99a590', '#9cabbd', '#748596', '#87919e', '#706777', '#82778d', '#baac92', '#919382'],
    coreName: '钢铁' //核心产业链名称
}



// WEBPACK FOOTER //
// ./src/store/state.js